import { App, Button, Dropdown, Popconfirm, Popover, Space } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useNavigate } from 'react-router-dom';
import { deleteFiscalYear, getFiscalYear } from '../../network/FiscalYear';
import { ModalAppFiscalYear } from '../../components/upeosoft/ModalApp/ModalApp';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { TbDotsVertical } from 'react-icons/tb';
import { FaCalendarAlt, FaCalendarTimes } from 'react-icons/fa';
import DashboardCards from '../Dashboard/DashboardCards';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
const FiscalYearTable = ({ t }) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getFiscalYear],
    queryFn: () => getFiscalYear(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteFiscalYear(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        client.invalidateQueries({
          queryKey: [queryKeys.getFiscalYear],
        });
      },
      onError: () => {
        message.error('Something went wrong!');
      },
    }
  );
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.FiscalYears,
      icon: <MdModeEditOutline />,
      onClick: () => {
        setOpen(true);
        setEdit(true);
        setEditId(record.name);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeletetheModeofFiscalYear + ` (${record?.name})`}
          description={t.areYouSure}
          okText={t.yes}
          cancelText={t.no}
          onConfirm={() => handleRemove.mutate(record?.name)}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.FiscalYears}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.FiscalYear,
      dataIndex: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.year).toLowerCase();
        const searchValue = value.toLowerCase();
        return name.includes(searchValue);
      },
    },
    {
      title: t.disabled,
      dataIndex: 'disabled',
      render: (text, record) => {
        return <StatusTag status={record?.disabled === 1 ? 'Yes' : 'No'} />;
      },
    },

    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 200,
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            {/* <Dropdown
              menu={{ items: items(record) }}
              trigger={['click']}
              // placement="bottomCenter"
            >
              <Button
                size="small"
                type="text"
                icon={<TbDotsVertical size={20} />}
              />
            </Dropdown> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
            {/* <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setOpen(true);
                setEdit(true);
                setEditId(record.name);
              }}
            >
              <Button size="small" type="primary">
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletetheModeofFiscalYear}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record.name)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm> */}
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      ...item,
      key: index,
    };
  });
  return (
    <div className="fiscal-year-table">
      {/* <Heading title={t.Finance} subTitle={t.FiscalYears} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          // titleBtn={t.AddFiscalYear}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
                setEdit(false);
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />{' '}
              {t.AddFiscalYear}
            </Button>
          }
          Placeholder={t.SearchFiscalYear}
          // pathBtn="/modeofpayments/add"
        />
      </div>
      <ModalAppFiscalYear
        t={t}
        open={open}
        setEdit={setEdit}
        setEditId={setEditId}
        setOpen={setOpen}
        edit={edit}
        record={editId}
      />
    </div>
  );
};

export default FiscalYearTable;
